import Cookies from 'js-cookie';

const _window = window;
export function checkXcx() {
  var env = _window.__wxjs_environment;
  if(env === 'miniprogram'){
    return true;
  }else{
    return false;
  }
}

export function checkLeFuXcx() {
  const _source = Cookies.get('df_channel_source')
  return checkXcx() && _source && _source == "lf"
}
